// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tw-0";